'use client';

import { Check, X, AlertCircle, Info } from 'lucide-react';

type ToastType = 'success' | 'error' | 'info';

interface ToastProps {
  message: string;
  type?: ToastType;
  onClose?: () => void;
}

const icons = {
  success: Check,
  error: AlertCircle,
  info: Info,
};

const styles = {
  success: 'bg-success text-white',
  error: 'bg-error text-white',
  info: 'bg-info text-white',
};

export function Toast({ message, type = 'success', onClose }: ToastProps) {
  const Icon = icons[type];

  return (
    <div
      role={type === 'error' ? 'alert' : 'status'}
      aria-live={type === 'error' ? 'assertive' : 'polite'}
      className={`fixed top-20 right-4 z-50 flex items-center gap-2 px-4 py-3 rounded-lg shadow-lg ${styles[type]}`}
    >
      <Icon size={18} />
      <span className="text-sm font-medium">{message}</span>
      {onClose && (
        <button onClick={onClose} className="ml-2 hover:opacity-80">
          <X size={16} />
        </button>
      )}
    </div>
  );
}

